<div class="modal-header">
  <h4 class="modal-title pull-left">Save As Favorite</h4>
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-modal-alert class="fixedPageAlert"></app-modal-alert>
  <form [formGroup]="saveLocationForm" (ngSubmit)="submit()">
    <div class="grid-1-col">
      <div class="form-group">
        <div
          class="d-flex flex-column justify-content-center"
          *ngIf="isLoading"
        >
          <app-spinner></app-spinner>
        </div>
        <label for="name">Name <span class="text-danger">*</span></label>
        <input
          #name
          type="text"
          formControlName="name"
          class="form-control form-control-lg"
          [ngClass]="{ 'is-invalid': f.name.dirty && f.name.errors }"
        />
        <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
          <div *ngIf="f.name.errors.required">required</div>
        </div>
        <div *ngIf="f.name.errors" class="invalid-feedback">
          <div *ngIf="f.name.errors.duplicateName">
            A favorite with this name already exists. Please enter a different
            name.
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            formControlName="isShared"
            class="custom-control-input"
            id="isShared"
          />
          <label class="custom-control-label" for="isShared"
            >Share this location with everyone in your account?</label
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-nowrap align-items-center">
      <div class="flex-grow-1"></div>
      <button
        type="reset"
        [disabled]="loading"
        (click)="bsModalRef.hide()"
        class="btn btn-outline-dark mr-2"
      >
        Cancel
      </button>
      <button
        [disabled]="saveLocationForm.invalid || loading"
        class="btn btn-primary"
      >
        Ok
      </button>
    </div>
  </form>
</div>
